import { motion } from "framer-motion";

const EASE = [0.76, 0, 0.24, 1];

// Swap any src for a real photo — send them over and they land here.
const SHOTS = [
  {
    src: "https://static.prod-images.emergentagent.com/jobs/354cc0d6-5b57-438b-8557-1a7d83c8045e/images/592b016e72ec4d4700bd3283ebdc03565e619a0d52f854abf7ba9b7065e82277.jpeg",
    caption: "The Amaze",
    tag: "Sedan",
  },
  {
    src: "https://static.prod-images.emergentagent.com/jobs/354cc0d6-5b57-438b-8557-1a7d83c8045e/images/3b9ef91a8527bd531776d529004d29435e1a3c62741aa2ed010abaaaa136b334.jpeg",
    caption: "The Ertiga",
    tag: "SUV",
  },
  {
    src: "https://static.prod-images.emergentagent.com/jobs/354cc0d6-5b57-438b-8557-1a7d83c8045e/images/eec1402a02fa58966b6713d04fbd8930418783c76d8687d5e8e64158d3ba86b6.jpeg",
    caption: "The Innova",
    tag: "SUV",
  },
  {
    src: "/crysta-photo.jpg",
    caption: "The Innova Crysta",
    tag: "SUV",
  },
  { src: "/owner-poster.jpg", caption: "The boss, on camera", tag: "Owner" },
  {
    src: "https://images.unsplash.com/photo-1542705959-878ca346eb20?q=85&w=1600&auto=format&fit=crop",
    caption: "Highway hours",
    tag: "Route",
  },
  {
    src: "https://images.unsplash.com/photo-1564668836804-05a2de350bb6?q=85&w=1600&auto=format&fit=crop",
    caption: "Night run",
    tag: "Route",
  },
];

export default function Gallery() {
  return (
    <section className="py-24 md:py-28 border-t border-white/10 overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 mb-12 flex items-end justify-between gap-8">
        <div>
          <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-signal mb-4">
            (03) — From the yard
          </p>
          <h2 className="font-display font-black uppercase leading-[0.95] text-4xl sm:text-5xl lg:text-6xl">
            On the road, lately.
          </h2>
        </div>
        <p className="hidden md:block font-mono text-[11px] uppercase tracking-[0.2em] text-zinc-500 shrink-0 pb-2">
          Scroll sideways →
        </p>
      </div>

      <div className="overflow-x-auto snap-x snap-mandatory no-scrollbar">
        <div className="flex gap-6 px-6 md:px-12 w-max">
          {SHOTS.map((s, i) => (
            <motion.figure
              key={s.caption}
              initial={{ opacity: 0, x: 40 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.6, ease: EASE, delay: (i % 3) * 0.07 }}
              data-testid={`gallery-tile-${i + 1}`}
              className="snap-start shrink-0 w-[72vw] sm:w-[340px] md:w-[380px] group"
            >
              <div className="overflow-hidden border border-white/10 aspect-[4/3]">
                <img
                  src={s.src}
                  alt={s.caption}
                  loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
              </div>
              <figcaption className="flex justify-between mt-3 font-mono text-[11px] uppercase tracking-[0.2em]">
                <span className="text-bone">{s.caption}</span>
                <span className="text-signal">{s.tag}</span>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
